import { observer } from "mobx-react";
import React from "react";
import { M365PulseFlyout } from "Shared/Components";
import { M365PulseFlyoutProps } from "Shared/Components/Flyout/M365PulseFlyout.types";
import { StyleConstants } from "Shared/Styles/StyleConstants";

import { AppLeftBar } from "./AppLeftBar";

const AppLeftBarFlyoutBase = (props: Omit<M365PulseFlyoutProps, "children">) => {
    const { onRequestClose } = props;

    return (
        <M365PulseFlyout {...props} position="start" width={`${StyleConstants.leftBarFlyoutWidth}px`} hideHeader onRequestClose={onRequestClose} isLightDismiss>
            <AppLeftBar onDismiss={onRequestClose} />
        </M365PulseFlyout>
    );
};

export const AppLeftBarFlyout = observer(AppLeftBarFlyoutBase);
